<template>
  <v-data-table
    dense
    item-key="id"
    disableSort
    :items-per-page="-1"
    :headers="headers"
    :items="teachings"
    hide-default-footer
  >
    <template v-slot:[`item.teacher.name`]="{ item }">
      <CardTeacherName v-if="item.teacher" :teacher="item.teacher" link />
      <span v-else style="color: red">Chưa có giáo viên</span>
    </template>
  </v-data-table>
</template>
<script>
import { mapState } from 'vuex'
import CardTeacherName from '@/components/basic/card/CardTeacherName.vue'

const originalHeaders = [
  {
    text: 'Tên môn học',
    value: 'subject.title',
    align: 'left',
    sortable: false
  },
  {
    text: 'Giáo viên bộ môn',
    value: 'teacher.name',
    align: 'left',
    sortable: false
  },
  {
    text: 'Số điện thoại',
    value: 'teacher.phone',
    align: 'left',
    sortable: false
  },
  {
    text: 'Email giáo viên',
    value: 'teacher.email',
    align: 'left',
    sortable: false
  }
]
export default {
  components: { CardTeacherName },
  data() {
    return {
      headers: originalHeaders
    }
  },
  computed: {
    ...mapState('classDetail', ['teachings'])
  }
}
</script>
